import styled from 'styled-components';

export const TertiaryNavContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-flow: row wrap;
  align-items: stretch;
  align-content: center;
  background-color: white;
  height: 54px;
  overflow: visible;
  position: relative;
  box-sizing: border-box;
  padding: 0 16px;
`;

export const TertiaryActionables = styled.div`
  align-content: 'center';
  padding: 0;
  margin: 0;
`;
